import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CargoDisputeForm = _resolveComponent("CargoDisputeForm")!
  const _component_CargoV2ManualInput = _resolveComponent("CargoV2ManualInput")!
  const _component_ScanTableSection = _resolveComponent("ScanTableSection")!
  const _component_CargoV2EditLayout = _resolveComponent("CargoV2EditLayout")!

  return (_openBlock(), _createBlock(_component_CargoV2EditLayout, {
    originCityCode: _ctx.detailData.originCityCode,
    destinationCityCode: _ctx.detailData.destinationCityCode,
    cargoType: _ctx.detailData.cargoType,
    id: _ctx.paramsId,
    no: _ctx.paramsNo,
    onSave: _ctx.onEditCargo,
    isDisabledEditBtn: _ctx.isDisabledEditBtn
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_CargoDisputeForm, { isEdit: "" }),
        _createVNode(_component_CargoV2ManualInput, { isEdit: true }),
        _createVNode(_component_ScanTableSection, { fromEdit: true })
      ])
    ]),
    _: 1
  }, 8, ["originCityCode", "destinationCityCode", "cargoType", "id", "no", "onSave", "isDisabledEditBtn"]))
}